<p>Using just readEndpoint</p>
<ui-grid #userSettings [readEndpoint]="apis.core.getAppUserSettingsByPartId((user.partId() || 0))"></ui-grid>
<br />

<ui-grid #userSettings [dsConfig]="userSettingsDsConfig" [showPanelHeader]="true"
    [panelHeaderConfig]="{panelHeaderTitle: 'Using Config object', titleClickToReload: true, showStandardFilterControls: true}"
    [responseTransform]="responseTransform" [pageSizes]="[5,8,20]"></ui-grid>

<!-- <ui-grid #participants
    [readEndpoint]="apis.core.getAdminParticipantsAll()"
    [showPanelHeader]="true"
    [panelHeaderConfig]="{panelHeaderTitle: 'Participants', titleClickToReload: true, settingsKey:'ParticipantsGrid', showStandardFilterControls: true, filterInputConfigs: [
        {type:'text', name:'lastName', label: 'Last Name'}
    ]}"

></ui-grid> -->